export default "__VITE_ASSET__DQrqQ9_1__"